module.exports = __webpack_public_path__ + "plugins/web/img/小智写文.fb023381.png";